/**
* Created By: Jennifer Mancilla
* Creation Date: 14/09/2022
* PBI: 78286 - Vista Paso 1 Cotizador Bepensa
*
* Last Modifier:
* Last Modification: 
*
* Feat: 
*
* version: 1.0.0
* copyright: 2022 INDUSTRIAS RESSER S.A DE C.V
*/
import React, { useEffect, useState, useRef } from 'react';
import { useAppSelector, useAppDispatch } from '../hooks/storeHooks';
import GetCP from '../apis/ApiCP';
import {
    getUserRFC,
    getUserFirstName,
    getUserSecondName,
    getUserFirstLastName,
    getUserSecondLastName,
    getUserState,
    getUserMunicipality,
    getUserObjColonias,
    getUserEmail,
    getUserCellphone,
    getUserStreet,
    getUserNumberHouse,
    getUserCP,
    getUserType,
    getUserContactMethod,
    getUserColony,
    getValidateUserRFC,
    getValidateUserEmail,
    getUserEnterprise,
    getUserNationality,
    byEmail,
    getUserGender,
    getGenderType,
    getLegalRepresentativeRFC,
    getLegalRepresentativeFirstName,
    getLegalRepresentativeSecondName,
    getLegalRepresentativeFirstLastName,
    getLegalRepresentativeSecondLastName,
    getLegalRepresentativeEmail,
    getLegalRepresentativeCellphone,
    getValidateLegalRepresentativeEmail,
    getValidateLegalRepresentativeRFC,
    getRevenueSpin
} from '../reducer/slices/DataCotizador';
import { validateRFCFisicaConNombre } from '../functions/ValidateSteps';
import { Grid } from '@mui/material';
import {
    ThirdStepContainer,
    TitleThirdStepContainer,
    txtdefault,
    contentTxt,
    finalContentTxt
} from '../styles/StepsStyles';
import {
    InputDefault,
    InputSelect, 
    InputSelectContact,
    NumericInput
} from '../components/Inputs/Inputs';
import { RegexRFCFisica, RegexRFCMoral, showEkatenaView } from '../utils/constants';
import { getAnalytics, logEvent } from '@firebase/analytics';
import styles from '../styles/Step.style';
import { message } from 'antd';
import { blockedPostalCodes  } from '../constants/blockedPostalCodes';
var validator = require('validator');

const useStyle = styles;

interface PersonType {
    type: number;
    disabled: boolean;
}

const arrayMethodSend: { id: Number, name: String }[] = [
    { id: 1, name: 'Correo electrónico' },
    { id: 2, name: 'S.M.S.' },
    { id: 3, name: 'WhatsApp' }
];

const arrayTipoPersona: { id: Number, name: String }[] = [
    { id: 0, name: 'Persona Moral'  },
    { id: 1, name: 'Persona Física con Actividad Empresarial' }
]

const arrayGender: { id: Number, name: String }[] = [
    { id: 0, name: 'Femenino' },
    { id: 1, name: 'Masculino'  }
]

const Validate = () => { }

/**
 * @title thirdStepView
 * @description Vista de la vista 3 del cotizador arrendamiento
 * @returns fragment
 */

const ThirdStepView = () => {
    const analytics = getAnalytics();
    const classes = useStyle();
    const dataCotizador = useAppSelector(state => state.DataCotizador);
    const dispatch = useAppDispatch();

    const [validateRFC, setValidateRFC] = useState<boolean | undefined>(undefined);
    const [rfcHelperText, setRfcHelperText] = useState<string>('RFC No válido');
    const [validateEmail, setvalidateEmail] = useState<boolean | undefined>(undefined);
    const [validateLegalRepRFC, setValidateLegalRepRFC] = useState<boolean | undefined>(undefined);
    const [legalRepRFCHelperText, setLegalRepRFCHelperText] = useState<string>('RFC No válido');
    const [personType] = useState<PersonType>({
        type: dataCotizador.userRFC.length === 13 ? 1 : 0,
        disabled: showEkatenaView && dataCotizador.userRFC.length > 0
    });
    // Evita que el useEffect de userType limpie el RFC al montar el componente;
    // solo debe limpiar cuando el usuario cambia el tipo de persona activamente.
    const isFirstRenderRef = useRef(true);
    const { ObjActividad } = useAppSelector(state => state.DataResponse);

    const Spacing = window.innerHeight < 950 ? 2 : 4;
    const title = 'Información del Negocio';

    useEffect(() => {
        logEvent(analytics, "view_third_screen");
    }, []);

    useEffect(() => {
        if (dataCotizador.userCP && dataCotizador.userCP.length === 5) {
            ValidateCP(dataCotizador.userCP);
        }
    }, []);

    // Al cambiar entre Persona Moral y Persona Física se limpia el RFC,
    // ya que cada tipo tiene formato y longitud diferente (12 vs 13 caracteres).
    useEffect(() => {
        if (isFirstRenderRef.current) {
            isFirstRenderRef.current = false;
            return;
        }
        dispatch(getUserRFC(''));
        setValidateRFC(undefined);
        dispatch(getValidateUserRFC(false));
    }, [dataCotizador.userType]);

    useEffect(() => {
        if (dataCotizador.userType === 1 && dataCotizador.userRFC.length === 13) {
            ValidateRFC(dataCotizador.userRFC, undefined, undefined, dataCotizador.userFirstName, dataCotizador.userSecondName);
        }
    }, [dataCotizador.userFirstLastName, dataCotizador.userSecondLastName, dataCotizador.userFirstName, dataCotizador.userSecondName]);

    useEffect(() => {
        if (dataCotizador.userType === 0 && dataCotizador.legalRepresentativeRFC.length === 13) {
            ValidateLegalRepRFC(dataCotizador.legalRepresentativeRFC, undefined, undefined, dataCotizador.legalRepresentativeFirstName, dataCotizador.legalRepresentativeSecondName);
        }
    }, [dataCotizador.legalRepresentativeFirstLastName, dataCotizador.legalRepresentativeSecondLastName, dataCotizador.legalRepresentativeFirstName, dataCotizador.legalRepresentativeSecondName]);

    const ValidateRFC = (value: string, overrideFirstLastName?: string, overrideSecondLastName?: string, overrideFirstName?: string, overrideSecondName?: string) => {
        const upper = value.toUpperCase();
        dispatch(getUserRFC(upper));
        if (!upper) {
            setValidateRFC(undefined);
            dispatch(getValidateUserRFC(false));
            return;
        }
        const formatOk = dataCotizador.userType === 0 ? RegexRFCMoral.test(upper) : RegexRFCFisica.test(upper);
        if (!formatOk) {
            setValidateRFC(false);
            setRfcHelperText('RFC No válido');
            dispatch(getValidateUserRFC(false));
            return;
        }
        if (dataCotizador.userType === 1 && upper.length === 13) {
            const pat = overrideFirstLastName ?? dataCotizador.userFirstLastName;
            const mat = overrideSecondLastName ?? dataCotizador.userSecondLastName;
            const firstName = overrideFirstName !== undefined ? overrideFirstName : dataCotizador.userFirstName;
            const secondName = overrideSecondName !== undefined ? overrideSecondName : dataCotizador.userSecondName;
            const check = validateRFCFisicaConNombre(upper, pat, mat, 'la persona física', firstName, secondName);
            setValidateRFC(check.valid);
            setRfcHelperText(check.errorMsg || 'RFC No válido');
            dispatch(getValidateUserRFC(check.valid));
        } else {
            setValidateRFC(formatOk);
            setRfcHelperText('RFC No válido');
            dispatch(getValidateUserRFC(formatOk));
        }
    }

    const ValidateLegalRepRFC = (value: string, overrideFirstLastName?: string, overrideSecondLastName?: string, overrideFirstName?: string, overrideSecondName?: string) => {
        const upper = value.toUpperCase();
        dispatch(getLegalRepresentativeRFC(upper));
        if (!upper) {
            setValidateLegalRepRFC(undefined);
            dispatch(getValidateLegalRepresentativeRFC(false));
            return;
        }
        const formatOk = RegexRFCFisica.test(upper);
        if (!formatOk) {
            setValidateLegalRepRFC(false);
            setLegalRepRFCHelperText('RFC No válido');
            dispatch(getValidateLegalRepresentativeRFC(false));
            return;
        }
        if (upper.length === 13) {
            const pat = overrideFirstLastName ?? dataCotizador.legalRepresentativeFirstLastName;
            const mat = overrideSecondLastName ?? dataCotizador.legalRepresentativeSecondLastName;
            const firstName = overrideFirstName !== undefined ? overrideFirstName : dataCotizador.legalRepresentativeFirstName;
            const secondName = overrideSecondName !== undefined ? overrideSecondName : dataCotizador.legalRepresentativeSecondName;
            const check = validateRFCFisicaConNombre(upper, pat, mat, 'el representante legal', firstName, secondName);
            setValidateLegalRepRFC(check.valid);
            setLegalRepRFCHelperText(check.errorMsg || 'RFC No válido');
            dispatch(getValidateLegalRepresentativeRFC(check.valid));
        } else {
            setValidateLegalRepRFC(formatOk);
            setLegalRepRFCHelperText('RFC No válido');
            dispatch(getValidateLegalRepresentativeRFC(formatOk));
        }
    }

    const ValidateEmail = (value: string) => {
        const validate = validator.isEmail(value);
        dispatch(getUserEmail(value));
        dispatch(getValidateUserEmail(validate));
        setvalidateEmail(validate);
    }

    const ValidateCP = async (value: string) => {
        dispatch(getUserCP(value));
        dispatch(getUserState(""));
        dispatch(getUserMunicipality(""));
        
        if (value.length === 5) {
            if (blockedPostalCodes .has(value)) {
                message.error("Actualmente no tenemos cobertura en este código postal");
                dispatch(getUserState(""));
                dispatch(getUserMunicipality(""));
                return;
            }
            GetCP(value).then((res: any) => {
                dispatch(getUserState(res.items.suburbs[0].State));
                dispatch(getUserMunicipality(res.items.suburbs[0].Municipality));
                
                const formattedSuburbs = res.items.suburbs.map((suburb: any) => {
                    return {
                        id: suburb.Id,
                        name: suburb.Name
                    };
                });
                
                dispatch(getUserObjColonias(formattedSuburbs));
            }).catch((error: any) => console.log(error));
        }
    };

    const MethodSend = (value: any) => {
        setMhetodSend(value); 
        dispatch(byEmail(value === 1));
    }

    const onChangeFirstName = (value: string) => dispatch(getUserFirstName(value.toUpperCase()));
    const onChangeSecondName = (value: string) => dispatch(getUserSecondName(value.toUpperCase()));
    const onChangeFirstLastName = (value: string) => dispatch(getUserFirstLastName(value.toUpperCase()));
    const onChangeSecondLastName = (value: string) => dispatch(getUserSecondLastName(value.toUpperCase()));
    const onChangeCellPhone = (value: any) => dispatch(getUserCellphone(value));
    const onChangeStreet = (value: string) => dispatch(getUserStreet(value.toUpperCase()));
    const onChangeNumberHouse = (value: string) => dispatch(getUserNumberHouse(value));
    const onChangeColony = (value: string) => dispatch(getUserColony(value));
    const onChangeRevenueSpin = (value: any) => dispatch(getRevenueSpin(value));
    const setUserType = (value: any) => dispatch(getUserType(value));
    const setMhetodSend = (value: any) => dispatch(getUserContactMethod(value));
    const setUserEnterprise = (value: any) => dispatch(getUserEnterprise(value.toUpperCase()));
    const setUserNationality = (value: any) => dispatch(getUserNationality(value.toUpperCase()));
    const setGenderType = (value: number) => {
          dispatch(getGenderType(value));
          if (value === 0) {
            dispatch(getUserGender('F'));
          } else{
            dispatch(getUserGender('M'));
          }
        }
    const { validateSecondStep } = useAppSelector(state => state.Validates);
    const onChangeLegalRepresentativeFirstName = (value: string) =>
    dispatch(getLegalRepresentativeFirstName(value.toUpperCase()));
    const onChangeLegalRepresantativeSecondName = (value: string) =>
        dispatch(getLegalRepresentativeSecondName(value.toUpperCase()));
    const onChangeLegalRepresentativeFirstLastName = (value: string) =>
        dispatch(getLegalRepresentativeFirstLastName(value.toUpperCase()));
    const onChangeLegalRepresentativeSecondLastName = (value: string) =>
        dispatch(getLegalRepresentativeSecondLastName(value.toUpperCase()));
    const onChangeLegalRepresentativeEmail = (value: string) => {
        const validate = validator.isEmail(value);
        dispatch(getValidateLegalRepresentativeEmail(validate));
        dispatch(getLegalRepresentativeEmail(value));
    };

    return (
        <div style={ThirdStepContainer}>
            <p className={classes.selectActiveTxt} style={{marginBottom: 15, marginTop:"-60px"}}>{title}</p>
            <Grid container spacing={Spacing} >
                <Grid item xs={12} sm={6}>
                   <InputSelect disabled={personType.disabled} label='Tipo de persona' value={dataCotizador.userType} setValue={setUserType} listItems={arrayTipoPersona} />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <InputDefault
                        label='RFC'
                        disabled={personType.disabled}
                        maxlength={dataCotizador.userType === 0 ? 12 : 13}
                        onChange={ValidateRFC}
                        value={dataCotizador.userRFC}
                        validate={validateRFC}
                        helperText={rfcHelperText}
                    />
                </Grid>
                {
                    dataCotizador.userType === 1 ? (
                        <>
                            <Grid item xs={12} sm={6}>
                                <InputDefault label='Primer nombre' onChange={onChangeFirstName} value={dataCotizador.userFirstName} />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <InputDefault label='Segundo nombre' onChange={onChangeSecondName} value={dataCotizador.userSecondName} />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <InputDefault label='Apellido paterno' onChange={onChangeFirstLastName} value={dataCotizador.userFirstLastName} />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <InputDefault label='Apelido materno' onChange={onChangeSecondLastName} value={dataCotizador.userSecondLastName} />
                            </Grid>
                             <Grid item xs={12} sm={6}>
                            <InputSelect label='Genero' value={dataCotizador.genderType} setValue={setGenderType} listItems={arrayGender} />
                            </Grid>
                            <Grid item xs={12}>
                            <p className={classes.selectActiveTxt} style={{marginBottom: 15}}>Datos de domicilio fiscal</p>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <InputDefault
                                    label='Correo electrónico'
                                    onChange={ValidateEmail}
                                    validate={validateEmail}
                                    value={dataCotizador.userEmail}
                                    helperText="Correo No válido" />
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <InputDefault
                                    label="Celular"
                                    onChange={onChangeCellPhone}
                                    isOnlyNumber
                                    value={dataCotizador.userCellphone}
                                />
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <NumericInput label='CPs' onChange={ValidateCP} maxlength={5} value={dataCotizador.userCP} />
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <InputDefault label='Estado' onChange={Validate} value={dataCotizador.userState} disabled />
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <InputDefault label='Municipio' onChange={Validate} value={dataCotizador.userMunicipality} disabled />
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <InputSelectContact label='Método de contacto' value={dataCotizador.userContactMethod} setValue={MethodSend} listItems={arrayMethodSend} />
                            </Grid>
                        </>
                    )
                        : dataCotizador.userType === 0 ? (
                            <>
                                <Grid item xs={12} sm={6}>
                                    <InputDefault label='Empresa' onChange={setUserEnterprise} value={dataCotizador.userEnterprise} />
                                </Grid>
                                <Grid item xs={12} >
                                    <p className={classes.selectActiveTxt}>Datos de domicilio fiscal</p>
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <NumericInput label='CP' onChange={ValidateCP} maxlength={5} value={dataCotizador.userCP} />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <InputDefault label='Estado' onChange={Validate} value={dataCotizador.userState} disabled />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <InputDefault label='Municipio' onChange={Validate} value={dataCotizador.userMunicipality} disabled />
                                </Grid>
                                <Grid item xs={12} sm={12}>
                                <p style={TitleThirdStepContainer}>Representante legal</p>
                                </Grid>
                                    <Grid item xs={12} sm={6}>
                                    <InputDefault
                                        label="RFC del representante legal"
                                        maxlength={13}
                                        onChange={ValidateLegalRepRFC}
                                        value={dataCotizador.legalRepresentativeRFC}
                                        validate={validateLegalRepRFC}
                                        helperText={legalRepRFCHelperText}
                                    />
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                    <InputDefault
                                        label="Primer nombre"
                                        onChange={onChangeLegalRepresentativeFirstName}
                                        value={dataCotizador.legalRepresentativeFirstName}
                                    />
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                    <InputDefault
                                        label="Segundo nombre"
                                        onChange={onChangeLegalRepresantativeSecondName}
                                        value={dataCotizador.legalRepresentativeSecondName}
                                    />
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                    <InputDefault
                                        label="Apellido paterno"
                                        onChange={onChangeLegalRepresentativeFirstLastName}
                                        value={dataCotizador.legalRepresentativeFirstLastName}
                                    />
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                    <InputDefault
                                        label="Apellido materno"
                                        onChange={onChangeLegalRepresentativeSecondLastName}
                                        value={dataCotizador.legalRepresentativeSecondLastName}
                                    />
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                    <InputDefault
                                        label="Correo electrónico"
                                        validate={dataCotizador.validatelegalRepresentativeEmail}
                                        helperText="Correo No valido"
                                        onChange={onChangeLegalRepresentativeEmail}
                                        value={dataCotizador.legalRepresentativeEmail}
                                    />
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                    <InputDefault
                                        value={dataCotizador.legalRepresentativeCellphone}
                                        label="Teléfono"
                                        onChange={(value: string) =>
                                        dispatch(getLegalRepresentativeCellphone(value))
                                        }
                                    />
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <InputSelectContact label='Método de contacto' value={dataCotizador.userContactMethod} setValue={MethodSend} listItems={arrayMethodSend} />
                                    </Grid>
                                
             
                            </>
                        ) : undefined
                }
            </Grid>

            <p style={{...txtdefault, marginTop: '3vh'}}>
                    El acreditado deberá tener entre 25 años y 68 años.
                </p>
                <p style={txtdefault}>
                    Deberá ser el accionista mayoritario de la empresa.
                </p>
                <p style={txtdefault}>
                    Deberá acreditar que es accionista desde el inicio de operación de la compañía o al menos en los últimos 5 años.
                </p>
                {
                    dataCotizador.userType === 1 &&(
                        <div style={{ marginTop: 50}}>
                            <p style={{ ...txtdefault, marginBottom: 10}}>
                            A continuación, es necesario autorizar la consulta al buró de crédito. 
                            Para ello enviaremos a tu medio de contacto elegido (correo o celular) 
                            un número de identificación personal (NIP) con el cual podrás autorizar 
                            a FinBe ABC realizar esta consulta.
                            </p>
                        </div>
                    )}
                

                {validateSecondStep && (<p style={{ ...contentTxt, marginTop: 5, color: 'red' }}>Favor de llenar todos los campos</p>)}
        </div>
        
    );
}

export default ThirdStepView;
